<template>
    
    <div class="col-12">
        <div class="card">
            <div class="row d-flex ">
                <div class="card-title">
                    <!-- <date-time-picker-with-option 
                    style="max-width: 250px"  
                    v-model="filter.dateRange"
                    @change="getStockMoveMent">
                    </date-time-picker-with-option>                 -->
                    <br/>
                    <div class="col  justify-content-end"  >
                        <span class="text-primary" style="font-size: 16px;">คงเหลือ <strong>{{ stock }} </strong> {{ unitStock }}</span> &nbsp;&nbsp;  &nbsp;&nbsp;  &nbsp;&nbsp;
                        <span v-if="data && data.selectType =='Row'">แสดงตาม {{typeView}} &nbsp;
                        <el-switch
                            v-model="checkType"            
                            @change="handleTypeViewChange"
                        ></el-switch></span>
                        
                       
                    <!-- </div>
                    <div class="col pt-2 justify-content-end" v-else >
                         <span>คงเหลือ {{ stock }}  {{ unitStock }}</span> -->
                    </div>
                   
                </div>
            </div>
           
            
            <!-- <br/> -->
            <div class="card-body" style="padding: 0px;">
                    <el-table
                    :data="products"
                    style="width: 100%;"
                    :height="windowHeight"
                    highlight-current-row 
                    show-summary
                    :summary-method="summary"  
                    sortable
                    >
                        <el-table-column prop="stockTransDate" label="วันที่" align="left" width="150" sortable>           
                            <template #default="scope">  
                                {{ formatDateFromISO(scope.row.stockTransDate) }}
                            </template>                             
                        </el-table-column>
                        <el-table-column prop="stockVoucherCode" label="เลขเอกสาร" align="left"></el-table-column>                                  
                        <el-table-column v-if="data && data.selectType =='Row'" :prop="checkType?'stockInWeight':'stockInQuantity'" label="In" align="right" width="140">
                            <template #default="scope">  
                                <div v-if="checkType" >{{ numberWithCommas(scope.row.stockInWeight, 2) }}  </div>
                                <div v-else >{{ numberWithCommas(scope.row.stockInQuantity, 0) }} </div>
                            </template>  
                        </el-table-column>    
                        <!-- <el-table-column v-else prop="stockInQuantity" label="Qty." align="right" width="140">
                            <template #default="scope">  
                               <div >{{ numberWithCommas(scope.row.stockInQuantity, 0) }} </div>
                            </template>  
                        </el-table-column>  -->
                        <el-table-column v-else  :prop="data && data.stockInOut=='In'?'stockInQuantity':'stockOutQuantity'" label="Qty." align="right" width="140">
                            <template #default="scope">  
                                <div v-if="data && data.stockInOut=='In'" >{{ numberWithCommas(scope.row.stockInQuantity, 0) }}  </div>
                                <div v-else >{{ numberWithCommas(scope.row.stockOutQuantity, 0) }} </div>
                            </template>  
                        </el-table-column>    
                        <el-table-column v-if="data && data.selectType =='Row'"  :prop="checkType?'stockOutWeight':'stockOutQuantity'" label="Out" align="right" width="140">
                            <template #default="scope">  
                                <div v-if="checkType" >{{ numberWithCommas(scope.row.stockOutWeight, 2) }}  </div>
                                <div v-else >{{ numberWithCommas(scope.row.stockOutQuantity, 0) }} </div>
                            </template>  
                        </el-table-column>    
                        <!-- <el-table-column v-else  prop="stockOutWeight" label="Weight" align="right" width="140">
                            <template #default="scope">  
                                <div>{{ numberWithCommas(scope.row.stockOutWeight, 2) }}  </div>                               
                            </template>  
                        </el-table-column> -->
                        <el-table-column v-else  :prop="data && data.stockInOut=='In'?'stockInWeight':'stockOutWeight'" label="Weight" align="right" width="140">
                            <template #default="scope">  
                                <div v-if="data && data.stockInOut=='In'" >{{ numberWithCommas(scope.row.stockInWeight, 2) }}  </div>
                                <div v-else >{{ numberWithCommas(scope.row.stockOutWeight, 2) }} </div>
                            </template>  
                        </el-table-column>       
                        <!-- <el-table-column prop="stockInOut" label="Out" align="center" width="150"></el-table-column>       
                        <el-table-column prop="stockQuantity" label="จำนวน" align="right" width="150">        
                            <template #default="scope">  
                                {{ numberWithCommas(scope.row.stockQuantity,0) }}
                            </template>                                
                        </el-table-column>      
                        <el-table-column prop="stockWeight" label="น้ำหนัก(กก.)" align="right" width="150"> 
                            <template #default="scope">  
                                {{ numberWithCommas(scope.row.stockWeight) }}
                            </template>                                       
                        </el-table-column>   -->
                    </el-table>
            </div>
        </div>
        <loading 
        v-model:active="isLoading"
        :loader="dots" 
        :is-full-page="false"/>          
    </div>
</template>


<script>
import { Modal } from "bootstrap";
import ApiService from "@/core/services/ApiService";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { numberWithCommas, formatDateFromISO, formatDateTimeFromISO } from "@/utils";
import Loading from 'vue-loading-overlay';
import { validateRole, role } from "@/helpers/role"
import DateTimePickerWithOption from '../../components/forms/DateTimePickerWithOption.vue';
import { DateTime } from 'luxon'

export default {
    props: {
        month:Number,
        year:String,
        stock:Number,
        unitStock:Number
       // data:Object
    }, 
    components: {
        Loading,
        // DateTimePickerWithOption,
    },
    data(){
        return{
            windowHeight: window.innerHeight - 180,
            productMoveMentModal: null,
            products: [], 
            data: [],      
            isLoading: false,   
            filter: {
                dateRange: [],
            },    
            type:"piece",
            checkType:false,
            typeView:"หน่วย",
            unit:"เส้น",    
        }
    },  
    methods:{
        setData(select) {  
            // this.data={};  
            // this.products=[];       
            this.data = select;
            this.getStockMoveMent();
           
        },   
        clearData() {  
            this.data={};  
            this.products=[];       
        },        
        getStockMoveMent: async function () {
            this.isLoading = true;
            try {
                const { data } = await ApiService.query("products/StockTransaction?SDate=" + DateTime.fromJSDate (this.filter.dateRange[0]).toFormat('yyyy-MM-dd') + "&EDate=" + DateTime.fromJSDate (this.filter.dateRange[1]).toFormat('yyyy-MM-dd') + "&ProductID=" + this.data.productID + "&PartnerCode=" + this.data.partnerCode+ "&Year=" + this.year+"&Month="+this.data.month+"&InOut="+this.data.stockInOut);
                // this.products=[];
                this.products = data;
            
            } catch (error) {
                console.log(error);
            }            

            this.isLoading = false;
        },
        summary({columns, data}) {
            const sums = [];
            columns.forEach((col, index) => {
                // if(index === 0) {
                // sums[index] = data.length + ' รายการ';
                // }

                
                if(col.property == "stockInQuantity" || col.property == "stockInWeight") {
                    let totalIn =  data.reduce(
                        (prev, curr) => {
                        return (curr.stockInOut == "In") ? prev + curr[col.property] : prev + curr[col.property]
                        },
                        0
                    )
                    sums[index] =col.property == "stockInQuantity"? numberWithCommas(totalIn, 0): numberWithCommas(totalIn, 2);
                }

                if(col.property == "stockOutQuantity" || col.property == "stockOutWeight") {
                    let totalOut =  data.reduce(
                        (prev, curr) => {
                        return (curr.stockInOut == "In") ? prev + curr[col.property] : prev - curr[col.property]
                        },
                        0
                    )
                    sums[index] =col.property == "stockOutQuantity"? numberWithCommas(totalOut, 0):numberWithCommas(totalOut, 2);
                }

            })    
            return sums;
        },        
        formatDateFromISO,
        numberWithCommas,
        formatDateTimeFromISO,
        handleTypeViewChange(){
            // console.log(this.checkType)
            if(this.checkType){
                this.type = "weight";
                this.typeView = "น้ำหนัก";
                this.unit="mt."
            }else{
                this.type = "piece";
                this.typeView = "หน่วย";
                this.unit="เส้น";
                
            }
        },
    },
    created () {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        this.filter.dateRange[0] = new Date(y, m, 1)
        this.filter.dateRange[1] = new Date(y, m + 1, 0)
        //await this.getStockMoveMent();
    },                 
}
</script>
